var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseGreyCircleFill(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-6-6h24v24H-6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#898B91",
    d: "M10.236 1.755a5.997 5.997 0 100 8.485 6.007 6.007 0 000-8.486zm-1.89 5.881a.5.5 0 01-.704.708L6.087 6.789a.126.126 0 00-.177 0L4.355 8.344a.51.51 0 01-.707 0 .5.5 0 010-.707l1.555-1.555a.125.125 0 000-.176L3.648 4.35a.5.5 0 01.705-.708l1.554 1.555a.125.125 0 00.177 0l1.555-1.555a.5.5 0 01.707.708L6.791 5.905a.125.125 0 000 .177l1.555 1.554z"
  }))));
}
export default SvgCloseGreyCircleFill;